import { render, staticRenderFns } from "./pbi-perfomance-tracking.page.vue?vue&type=template&id=5f3b7eaf"
import script from "./pbi-perfomance-tracking.page.vue?vue&type=script&lang=ts"
export * from "./pbi-perfomance-tracking.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports